import React from 'react';
const ReactMarkdown = require('react-markdown')

class Footer extends React.Component{

    render(){
        return (
            <div className="row footer" style={this.props.fields.footerColor?{backgroundColor:this.props.fields.footerColor}:{backgroundColor:this.props.secondColor}}>
                <div className="col-5 offset-1 footer-text">
                    <ReactMarkdown escapeHtml={false} source={this.props.fields.footerText}/>
                </div>
                <div className="col-5 offset-1 footer-social">
                    <div className="footer-social-text">{this.props.fields.socialMediaTitle}</div>
                    <div className="footer-social-icons">
                        {
                            this.props.fields.socialMediaIcons && this.props.fields.socialMediaIcons.map((icon, i) => {
                                return <div className="footer-social-icon">
                                    <a target="_blank" href={this.props.fields.socialMediaLinks[i]}>
                                        <img src={icon.fields.file.url}/>
                                    </a>
                                </div>
                            })
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default Footer;
